/**
 * Point d’entrée unique — HelmetProvider requis en racine (#1120 navigation SPA).
 * Import puis réexport local : un `export { X } from` est vidé par React Refresh
 * (webpack : « module has no exports »).
 */
import {
  Helmet as HelmetBase,
  HelmetProvider as HelmetProviderBase,
} from 'react-helmet-async';

export const Helmet = HelmetBase;
export const HelmetProvider = HelmetProviderBase;
